export default {
  'cart:title': 'Cart',
  'cart:sub-title': '{value} Items',
  'cart:top-message-1': 'Good choice!',
  'cart:top-message-2': 'Here are your products',
  'cart:available-payment-methods': 'We accept',
  'cart:available-payment-methods-2': 'Pay securely with',
  'cart:empty:title': 'Your cart is empty.',
  'cart:empty:description':
    'Browse through our shop and find delicious and healthy pet food for your four-legged friend.',
  'cart:empty:description-test':
    'Still looking for the right food? Try our food advisor.',
  'cart:empty:button': 'To the food advisor',
  'cart:product:interval': 'Delivery',
  'cart:minimum-basket-value': 'Minimum order value',
  'cart:free-shipping-notice':
    '<span>{insufficientMoney}</span> more until <span>free shipping</span>',
  'cart:free-shipping-notice-test':
    '{insufficientMoney} more until free shipping',
  'cart:summary:shipping:free': 'Free',
  'cart:summary:shipping:free-test': '<div><span>€4.90</span> €0.00</div>',
  'cart:summary:shipping:min-price': 'from {price}',
  'cart:empty:dogs-button': 'FOR DOGS',
  'cart:empty:cats-button': 'FOR CATS',
  'cart:mbv:notice-text': 'Amount needed to reach the minimum order value',
  'cart:mbv:notice-text-test':
    'The minimum order value is {mov}. Missing {insufficientMoney}',
  'cart:mbv:cta-text': 'Why we have a minimum order value for frozen orders',
  'cart:mbv:modal:title': 'Minimum order value for fresh menus',
  'cart:mbv:modal:description': `
    <p>
      Please note that orders containing frozen products have a minimum order value of €30.
    </p>
    {br}
    <p>
      You can top up the remaining <b>{insufficientMoney}</b> with products of your choice. Do you already know our high-quality BARF supplements like our Mineral Mix or one of our oils?
    <p/>
  `,
  'cart:mbv:modal:cta': 'Continue shopping now',
  'cart:sub-total': 'Subtotal incl. VAT',
  'cart:sub-total-with-disscounts': 'Subtotal incl. discount',
  'cart:savings': 'You save',
  'cart:savings:subscription': 'Subscription discount',
  'cart:savings:referal': 'Refer a friend',
  'cart:savings:credit': 'Pets Deli credit',
  'cart:savings:offer': 'Offer',
  'cart:savings:offer:without-badge': 'Offer',
  'cart:savings:subscription-discount': 'Subscription discount',
  'cart:savings:coupon': 'Voucher {couponCode}',
  'cart:total': 'Total amount',
  'cart:total:test': 'Price incl. VAT',
  'cart:total-with-shipping:test': 'Price incl. VAT and shipping',
  'cart:tax': 'incl. VAT',
  'cart:tax:with-shipping': 'incl. VAT & shipping',
  'cart:tax:with-free-shipping': 'incl. VAT & free shipping',
  'cart:shipping': 'Shipping',
  'cart:shipping:new-customer':
    'Shipping <span>(Free for new customers)</span>',
  'cart:shipping:new-customer-test': 'Free shipping',
  'cart:shipping:existing-customer': 'Shipping <span>(Free from €60)</span>',
  'cart:go-to-checkout': 'Go to checkout',
  'cart:gift-items:title': 'Secure up to 4 gifts',
  'cart:gift-items:free': 'Free',
  'cart:preorder-shipping-delay-title': 'Note',
  'cart:preorder-mixed-shipping-delay':
    'Shipping of the Advent calendars will take place from October 2020. The rest of your order will be processed and delivered immediately.',
  'cart:preorder-only-shipping-delay':
    'Shipping of the Advent calendars will take place from October 2020. Look forward to it!',
  'cart:discount:Referal': 'Refer a friend',
  'cart:discount:Credit': 'Pets Deli credit',
  'cart:discount:Coupon': 'Pets Deli voucher',
  'cart:discount:Custom': 'Pets Deli voucher',
  'cart:discount-error:referal:ItemsTotalToSmall':
    'Amount needed to get the refer a friend discount',
  'cart:discount-error:referal:ItemsTotalToSmall-test':
    'Amount needed to get the refer a friend discount {insufficientMoney}',
  'cart:discount-error:referal:InvalidReferal':
    'Invalid referral code. Please contact customer service if you believe this is an error.',

  'cart:bonus-program:summary': '{value} points for your purchase',
  'cart:bonus-program:details': 'Details',

  'cart:bonus-program:info-title': 'Pets Deli Bonus Program',
  'cart:bonus-program:info-subtitle':
    'Collect points with every order with our bonus program and exchange them for shopping credit. You can view your point balance at any time in your account under → "<a>Bonus Program</a>".',
  'cart:bonus-program:info-benefit-1': '€1 purchase value = 1 point',
  'cart:bonus-program:info-benefit-2': '200 bonus points = €5',
  'cart:bonus-program:info-benefit-3': '500 bonus points = €15',
  'cart:bonus-program:more-info':
    'And be sure to secure extra points on special occasions and promotions!',
  'cart:interval-selection:regular-delivery': 'Regular delivery',
  'cart:interval-selection:activate-subscription': 'Activate subscription',
  'cart:interval-selection:order-type': 'Delivery',
  'cart:interval-selection:one-off': 'One-time',
  'cart:interval-selection:deactivate-subscription': 'No subscription',

  'cart:subs-info-modal:header': 'THE PETS DELI FOOD SUBSCRIPTION',
  'cart:subs-info-modal:instruction:point-1':
    'Simply search for your favorite products in the shop',
  'cart:subs-overlay:title':
    'Adjust the subscription so that it suits you best',
  'cart:subs-overlay:accept-selection': 'Accept selection',
  'cart:subs-info-modal:instruction:point-2':
    'Select size & quantity on the product pages',
  'cart:subs-info-modal:instruction:point-3':
    'Activate regular delivery & set delivery interval',
  'cart:subs-info-modal:instruction:point-4': 'Order as usual...done!',
  'cart:subs-info-modal:benefits:header': 'CONVENIENT, FLEXIBLE, RISK-FREE!',
  'cart:subs-info-modal:benefits:point-1': 'No minimum contract term',
  'cart:subs-info-modal:benefits:point-2':
    'Can be canceled independently at any time',
  'cart:subs-info-modal:benefits:point-3':
    'Permanently save {discount}% with every delivery',
  'cart:subs-info-modal:benefits:point-4':
    'Change of delivery interval and pausing of the subscription possible at any time',

  'cart:summary:pay-also-with': 'Or pay directly with',
  'cart:summary:pay-also-with-test': 'Or',
  'cart:summary:button:express-checkout-mobile': 'Express Checkout',

  'cart:gift-selection:header': 'Secure a free gift from Pets Deli',
  'cart:gift-selection:message:part-1': 'From a',
  'cart:gift-selection:message:part-2': 'purchase value of',
  'cart:gift-selection:message:part-3':
    ' you will receive a free gift from us with your order.',
  'cart:gift-selection:header-with-gift': 'Your free gift from Pets Deli',

  'cart:money-back:title': '30-Day Taste Guarantee 😋',
  'cart:money-back:sub-title':
    "We offer you a free food alternative if it doesn't taste good.",
  'cart:money-back:modal:title':
    'Pets Deli solves food problems - demonstrably.',
  'cart:money-back:modal:sub-title':
    "Our motto: <b>Doesn\'t taste good, doesn\'t exist!</b> If your furry friend doesn\'t like it contrary to expectations, you will receive a free food alternative from us.",
  'cart:money-back:modal:list-title': "It\'s that simple:",
  'cart:money-back:modal:step-1':
    'Simply fill out our contact form, which you can find here. If you have a problem, please use "Taste Guarantee" <a>Submit request - PETS DELI</a>',
  'cart:money-back:modal:step-2':
    'Receive a free food consultation with our nutrition experts to find the right alternative product suitable for your needs.',
  'cart:money-back:modal:step-3':
    'We will ensure that you receive your new product as quickly as possible.',

  'cart:upsell-product:title': 'Pssst - this offer is only for you!',
  'cart:upsell-product:cta': 'Add to order',
  'cart:upsell-product:cta-item-added': 'Added',
  // PT-4103 Frontend :: A/B test :: Improve Voucher Redemption Communication
  // https://petsdeli.atlassian.net/browse/PT-4103
  'cart:coupon:successfully-applied':
    'The coupon {couponCode} has been successfully applied and will be applied during the checkout process.',
  'cart:coupon:successfully-applied-variant:close': 'Close',

  'cart:discount-modal:greeting': `we have a hot deal for you!`,
  'cart:discount-modal:title': 'Especially for you',
  'cart:discount-modal:discount': '<span>{percentage}%</span> off {category}',
  'cart:discount-modal:category:supplements': 'Food supplements',
  'cart:discount-modal:category:snacks': 'Snacks',
  'cart:discount-modal:category:snacks:subsscription':
    'Snacks with regular delivery',
  'cart:discount-modal:category:mov': 'from €40 order value',
  'cart:discount-modal:category:cta:discover-offers': 'DISCOVER TOP OFFERS',
  'cart:discount-modal:category:cta:add-snacks': 'Add snacks',
  'cart:discount-modal:category:cta:subscribe-snacks': 'SUBSCRIBE TO SNACKS',
  'cart:discount-modal:category:cta:go-to-checkout': 'Continue to checkout',

  'cart:coupon-modal-pop-up:successfully-applied':
    '<p>Congratulations!</p>Your voucher <strong> {couponCode} </strong> has been redeemed.',
  'cart:coupon-modal-pop-up:minimum-order-value':
    'from {miniminumOrderValue}€ order value',

  'cart:subs-reminder-modal-pop-up:title': 'Smart savings with a subscription!',
  'cart:subs-reminder-modal-pop-up:title:success': 'Successful',
  'cart:subs-reminder-modal-pop-up:title:success:text':
    'Yay! You just saved <br></br> <span></span> <br></br>!',
  'cart:subs-reminder-modal-pop-up:title:success:info-text':
    'You can edit your subscription in the cart or in your account after checkout.',
  'cart:subs-reminder-modal-pop-up:sub-title:scenario':
    'Do it regularly and save <span></span> with a subscription!',
  'cart:subs-reminder-modal-pop-up:info-abo':
    'Subscription <b>flexibly adjustable, pausable & cancellable</b> at any time',
  'cart:subs-reminder-modal-pop-up:interval-selector:title':
    'Choose your delivery interval',
  'cart:subs-reminder-modal-pop-up:info-abo:show-all-button': 'Show All',
  'cart:subs-reminder-modal-pop-up:CTA1': 'Subscribe and Save',
  'cart:subs-reminder-modal-pop-up:CTA2': 'Continue to Checkout',
  'cart:subs-reminder-modal-pop-up:go-to-checkout': 'Pay Now',

  'cart:apple-pay-modal:title': 'Apple Pay Error',
  'cart:apple-pay-modal:content': 'Something went wrong! Please try again.',

  'cart:bonus-points': 'Bonus Points',
  'cart:bonus-points:amount':
    '{amount, plural, =0 {# points} one {# point} other {# points}}',
  'cart:bonus-points:standard': '{amount} purchase value',
  'cart:bonus-points:extra-bonus': 'Extra points',
  'cart:bonus-points:multiplier': '{conversionRate} times points',
  'cart:bonus-points:new-customer': 'Welcome points (for new customers)',

  'cart:modal-discount-selector:title': 'Please select',
  'cart:modal-discount-selector:info:credits-and-coupon':
    'The Pets Deli credit and the voucher {couponCode} have been added to your cart. However, both cannot be used for one purchase. Please select the option you want to use.',
  'cart:modal-discount-selector:info:referal-and-coupon':
    'The Refer a Friend bonus and the voucher BF30 have been added to your cart. However, both cannot be used for one purchase. Please select the option you want to use.',
  'cart:modal-discount-selector:credits:title': 'Pets Deli Credit',
  'cart:modal-discount-selector:credits:cta': 'Use credit',
  'cart:modal-discount-selector:coupon:title': 'Voucher',
  'cart:modal-discount-selector:coupon:titl-with-coupon':
    '{couponCode} Voucher',
  'cart:modal-discount-selector:coupon:cta': 'Use voucher',
  'cart:modal-discount-selector:referal:title': 'Refer a Friend Bonus',
  'cart:modal-discount-selector:referal:cta': 'Use bonus',
  'cart:oos-modal:title': 'Oops, some products are out of stock',
  'cart:oos-modal:subtitle':
    '{itemsCount, plural, one {We have to remove the following product from the cart because it is no longer in stock.} other {We have to remove the following products from the cart because they are no longer in stock.}}',
  'cart:oos-modal:cta:continue-shopping': 'Continue shopping',
  'cart:oos-modal:cta:go-to-checkout': 'Go to checkout',

  'cart:low-rate-subscription-modal:very-low:title':
    'Did you create a subscription?',
  'cart:low-rate-subscription-modal:very-low:description':
    'It seems like you subscribed to products in the cart*. Was that intentional?<span>*A minimum order value of {amount} applies to the subscription.</span>',
  'cart:low-rate-subscription-modal:very-low:cta:primary':
    'Cancel subscription and go to checkout',
  'cart:low-rate-subscription-modal:very-low:cta:secondary':
    'Increase subscription to {amount}',
  'cart:low-rate-subscription-modal:low:title': 'Subscribe more, save more!',
  'cart:low-rate-subscription-modal:low:description':
    'A minimum order value of {amount} applies to the subscription. Please add more items to reach this value.',
  'cart:low-rate-subscription-modal:low:cta:primary':
    'Increase subscription to {amount}',
  'cart:low-rate-subscription-modal:low:cta:secondary':
    'Cancel subscription and go to checkout',
  'cart:low-rate-subscription-modal:note':
    'Subscription <span>flexibly adjustable, pausable & cancellable</span> at any time',
  'cart:low-rate-subscription:group:title:success':
    'Now you can subscribe and save money! 🥳',
  'cart:low-rate-subscription:group:title:missing-amount':
    'Please add {amount} more for the subscription.',
  'cart:low-rate-subscription:modal-info:title':
    'Your savings with every order',
  'cart:low-rate-subscription:modal-info:original-price':
    'Original price incl. VAT',
  'cart:low-rate-subscription:modal-info:subscription-discount':
    'Regular delivery discount',
  'cart:low-rate-subscription:modal-info:coupon-discount':
    '{couponCode} voucher',
  'cart:low-rate-subscription:modal-info:total-price': 'Your price incl. VAT',
  'cart:low-rate-subscription:modal-info-note':
    'Subscription from <span>{amount} minimum order value.</span> Fewer deliveries help <span>reduce emissions.</span>',
  'cart:tiny-cart:urgency-note':
    'Your products are reserved for only {minutes} minutes',
};